import { InjectionToken } from '@angular/core';

export const FULLSCREEN_MODAL_REF = new InjectionToken<unknown>('FULLSCREEN_MODAL_REF');
export const FULLSCREEN_MODAL_CONFIG = new InjectionToken<unknown>('FULLSCREEN_MODAL_CONFIG');
export const FULLSCREEN_DIALOG_DATA = new InjectionToken<unknown>('FULLSCREEN_DIALOG_DATA');

